import { render, staticRenderFns } from "./WelcomePlaceholder.vue?vue&type=template&id=0c3eaa90"
import script from "./WelcomePlaceholder.vue?vue&type=script&lang=js"
export * from "./WelcomePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports